import { render, staticRenderFns } from "./TraxAccountUserCrudTable.vue?vue&type=template&id=43426858"
import script from "./TraxAccountUserCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports